__turbopack_context__.v({
  "cards": "MobileTutorial-module-scss-module__eE3hLG__cards",
  "column": "MobileTutorial-module-scss-module__eE3hLG__column",
  "intro": "MobileTutorial-module-scss-module__eE3hLG__intro",
  "layoutBlock": "MobileTutorial-module-scss-module__eE3hLG__layoutBlock",
  "twoCards": "MobileTutorial-module-scss-module__eE3hLG__twoCards",
});
